import React, { type ReactNode } from "react";

interface StepProps {
  title: string;
  description?: string;
  children: ReactNode;
}

export function Step({ title, description, children }: StepProps) {
  return (
    <section className="mt-4 border-2 border-ink px-5 py-5">
      <h2 className="font-mono text-sm font-bold uppercase tracking-[0.15em] text-ink">
        {title}
      </h2>
      {description ? (
        <p className="mt-1 text-sm text-muted">{description}</p>
      ) : null}
      <div className="mt-5">{children}</div>
    </section>
  );
}
